import performOperations from "@/utils/performOperations";
import {performObjectOperations} from "@/utils/performObjectOperations"
import { arrayActions, getFilterState, stringActions, updateState } from "./Actions/actionInterface";
import { getAllCookies } from "./clientStorageActions";
import { convertToLabel } from "@/utils/convertToLabelFromPath";
// import Cookies from "js-cookie"

const getData = (hierarchy: updateState, storeState: any, globalState?: any, fullGlobalState?: any, reduxState?: any, collectionStateOrPayload?: any) => {  
  const state = Array.isArray(storeState) ? [...storeState] : typeof storeState === "string" ? storeState : { ...storeState ?? {} };
  const resolveArrayData = (state: any, hierarchy: updateState) => {
    const arrayData = hierarchy?.key === undefined ? state : state?.[hierarchy?.key] ?? globalState?.[hierarchy?.key] ?? [];
    if (hierarchy?.index !== undefined) {
      let extractedIndex = hierarchy?.index;
      if (typeof hierarchy?.index === "object") {
        const indexSource = collectionStateOrPayload
        extractedIndex = getData(hierarchy?.index, indexSource);
      }

      if (hierarchy?.field) {
        return getDataFromHierarchy(
          arrayData?.[parseInt(extractedIndex?.toString())],
          hierarchy?.field
        );
      } else {
        return arrayData?.[parseInt(extractedIndex?.toString())]
      }
    } else if (hierarchy?.arrayActions?.length) {
      const arrayActions = hierarchy?.arrayActions;
      for (let i = 0; i < arrayActions?.length; i++) {
        switch (arrayActions[i]?.type) {
          case "length":
            return arrayData?.length
            break;
          case "length-with-filter":
            return arrayData?.filter((arrData:any)=>{
              //@ts-ignore
              const data = arrayActions[i].filter !== undefined ?  getData(arrayActions[i].filter ,arrData) : undefined;

              const dynamicValueState = arrayActions[i].filter?.dynamicValue?.source === "GLOBAL" ? globalState: arrData
              const dynamicValueData = arrayActions[i].filter?.dynamicValue !== undefined ? getData(arrayActions[i].filter?.dynamicValue ,dynamicValueState) : undefined;
              if(data === arrayActions[i].filter?.value || data === dynamicValueData){
                return arrData
              }
            })?.length ?? 0
            break;
          case "filter":
            const data = arrayData?.filter((arrData:any)=>{
              //@ts-ignore
              if(arrayActions[i]?.conditions && arrayActions[i]?.conditions?.length){
                //@ts-ignore
                const conditions: any[] = arrayActions[i]?.conditions;

                return conditions.every((condition)=>{
                  const data = condition !== undefined ? condition?.key ? getData((condition as any), arrData) : arrData : undefined;
                  const dynamicValueState = condition?.dynamicValue?.source === "GLOBAL" ? globalState : condition?.dynamicValue?.source === "DEFAULT" ? collectionStateOrPayload : arrData
                  const dynamicValueData = typeof collectionStateOrPayload !== "object" ? collectionStateOrPayload : condition?.dynamicValue !== undefined ? getData(condition?.dynamicValue, dynamicValueState) : undefined;
                  return getFilteredData(dynamicValueData, data, condition);
                });
                
              }else{
                const data = arrayActions[i].filter !== undefined ? arrayActions[i].filter?.key ? getData((arrayActions[i].filter as any), arrData) :arrData : undefined;
                const dynamicValueState = arrayActions[i].filter?.dynamicValue?.source === "GLOBAL" ? globalState : arrayActions[i].filter?.dynamicValue?.source === "DEFAULT" ? collectionStateOrPayload : arrData
                const dynamicValueData = typeof collectionStateOrPayload !== "object" ? collectionStateOrPayload : arrayActions[i].filter?.dynamicValue !== undefined ? getData(arrayActions[i].filter?.dynamicValue, dynamicValueState) : undefined;
                return getFilteredData(dynamicValueData, data, (arrayActions[i].filter as any));
              }
            }).map((item:any)=>{
              //@ts-ignore
              if(arrayActions[i]?.keysToIncludes){
                //@ts-ignore
                const keysToIncludes = arrayActions[i]?.keysToIncludes;
                
                return getData(keysToIncludes,item);
              }else{
                return item;
              }
            });

            return data;
            break;
          case "push":
            arrayData?.push(storeState)
            return arrayData;
          case "unshift":
            arrayData?.unshift(storeState)
            return arrayData;
          case "findIndex":
            return arrayData?.findIndex(
              (item: any) =>
                getData(
                  arrayActions[i]?.find ?? { key: "" },
                  arrayActions[i]?.find?.source === "DEFAULT"
                    ? collectionStateOrPayload
                    : arrayActions[i]?.find?.source === "GLOBAL"
                    ? fullGlobalState
                    : storeState
                ) ===
                getData(
                  arrayActions[i]?.findFrom ?? { key: "" },
                  item,
                  globalState,
                  fullGlobalState,
                  reduxState,
                  collectionStateOrPayload
                )
            );
          case "reduce":
            let defaultData;
            switch (arrayActions[i]?.reduceType) {
              case "SUM":
                defaultData = 0;
                break;
              case "OBJ_JOIN":
                defaultData = {};
                break;
            }
            return arrayData?.reduce((acc: any, item: any) => {
              return acc + (getData(arrayActions[i]?.reduce ?? { key: "" }, item) ?? 0);
            }, defaultData);
          case "remove":
            const index = arrayData?.findIndex((item: any) => {
              return (
                // @ts-ignore
                (typeof item === 'object' && arrayActions[i]?.compareWith? getData(arrayActions[i]?.compareWith, item) : typeof item === 'object' ? getData(arrayActions[i]?.compare, item) : item) ===
                // @ts-ignore
                getData(arrayActions[i]?.compare, arrayActions[i]?.compare?.source === "DEFAULT" ? collectionStateOrPayload : state)
              );
            });
            arrayData.splice(index, 1);
            break
          case "removeWithIndex":
             arrayData.splice(collectionStateOrPayload?.index, 1);
            
            return arrayData;
            break
          case "update-with-compare":
            //@ts-ignore
            const state = arrayActions[i].compare.source === "GLOBAL" ? fullGlobalState : storeState;
            //@ts-ignore
            const updateThisArray = arrayActions[i].compare !== undefined ? getData((arrayActions[i].compare ?? {}), state) : []

            const data1 = updateThisArray?.map((item: any, itemIdx: number) => {
              const matchObj = arrayActions[i].compare !== undefined ? arrayData?.filter((matchItem: any) => {

                //@ts-ignore
                return getData(arrayActions[i].compare.dynamicValue, matchItem) === getData(arrayActions[i].compare.compareWith, item)
              }) : [];


              const updateArrs = arrayActions[0].compare?.updateKeys?.reduce((acc, key) => {
                const [newKey, oldKey] = key.split(":");
                //@ts-ignore
                acc[newKey] = matchObj[0]?.[oldKey];
                return acc;
              }, {})

              return {
                ...item,
                ...updateArrs
              }
            })
            return data1;
            break;
          case "join":
            return arrayData.join(arrayActions[i]?.firstArgs)
            break;
          case "map":
            return arrayData.map((data:any)=>{
              let tempObject:any = arrayActions[i]?.appendInOld?{...data}:{};
              const keyUpdationArray = arrayActions[i]?.updateKeysArray ?? []
              for (let k = 0; k < keyUpdationArray.length; k++) {
                const keyObject = keyUpdationArray[k];
                tempObject[keyObject.key] = typeof keyObject.getData === "object" ? getData(keyObject.getData,keyObject.getData.source === "GLOBAL" ? fullGlobalState : data, globalState, fullGlobalState, reduxState, collectionStateOrPayload): keyObject.getData;
              }
              const operations = arrayActions[i]?.operations ?? [];

              if(operations?.length > 0){
                return performOperations(data,operations,globalState,fullGlobalState,reduxState,collectionStateOrPayload);
              }
              return tempObject;

            })
            break;
          case "create-array":
            const generateExtractedValues = (keyStructure: any, obj:any) => {
              let object: any = {};
              
              Object.entries(keyStructure).forEach(([key, valueObj]: any) => {
                object[key] = getData(
                  valueObj,
                  valueObj.source === "REDUX"
                    ? reduxState
                    : valueObj.source === "GLOBAL"
                    ? fullGlobalState
                    : valueObj.source === "DEFAULT"
                    ? obj 
                    : globalState
                );
              });
            
              return object;
            };
            return Array.from(arrayData, (obj:any) => {
              return arrayActions[i]?.arrayItemsType === "number" ? getData(arrayActions[i].create ?? {key: ""},obj, globalState, fullGlobalState, reduxState, collectionStateOrPayload): generateExtractedValues(arrayActions[i].create, obj)
            })
            break;
          case "sort":
            if (typeof arrayData[0] === "object") {
              arrayData?.sort((a: any, b: any) => {
                const key = arrayActions[i]?.sortByKey;
                const order = arrayActions[i]?.orderby ?? "ASC";

                if (key && key in a && key in b) {
                  const valueA = parseFloat(a[key]);
                  const valueB = parseFloat(b[key]);
                  if (valueA < valueB) {
                    return order === "ASC" ? -1 : 1;
                  }
                  if (valueA > valueB) {
                    return order === "ASC" ? 1 : -1;
                  }
                  return 0;
                }

                return 0;
              });
            } else {
              arrayData.sort();
            }

            if (arrayActions[i]?.inDescending) {
              arrayData.reverse();
            }
            return arrayData;
            break;
          default:
            break;
        }
      }
    }
    return arrayData;
  }

  const resolvedStringOperations = (firstString: string, stringActions: stringActions[]) => {
    for (let i = 0; i < stringActions.length; i++) {
      const action = stringActions[i];

      switch (action.type) {
        case "concat":

          let stringSource = null;
          switch (action?.otherStringsObjectLocationStructure) {
            case "GLOBAL":
              stringSource = fullGlobalState;
              break;
            case "REDUX":
              stringSource = reduxState;
            case "DEFAULT":
              stringSource = state;
              break;
            case "COOKIES":
              stringSource = getAllCookies();
              break;
            default:
              stringSource = getData(action?.otherStringsObjectLocationStructure, action?.otherStringsObjectLocationStructure?.source === "GLOBAL" ? fullGlobalState : action?.otherStringsObjectLocationStructure?.source === "REDUX" ? reduxState : storeState, globalState, fullGlobalState, reduxState, collectionStateOrPayload);
          }
          const keys = action?.otherStringsKeys;
          for (let j = 0; j < keys?.length; j++) {
            const stringKey = keys[j];
            let generatedString:string = stringSource?.[stringKey] ?? "";
            if( j <= 0 ){
              if(action?.addAfterFirstString === false){
                firstString = firstString?.concat(generatedString)
              }else{
                firstString = firstString?.concat(action?.preString ?? "", generatedString)
              }
            }else{
              firstString = firstString?.concat(action?.preString ?? "", generatedString)
            }
            
          }
          return (action?.addAtFirst ? action?.preString ?? "" : "") + firstString + (action?.addAtLast ? action?.preString ?? "" : "");
          break;
        case "split":
          const array = firstString.split(action?.splitBy ?? "",action?.limit);
          return array;
          break
        case "caseConversion":
          switch (action.case) {
            case "toLower":
              firstString = firstString?.toLowerCase();
              return firstString
              break;
            case "toUpper":
              firstString = firstString?.toUpperCase();
              return firstString
              break;
            case "capitalizeFirst":
              firstString = firstString?.charAt(0)?.toUpperCase() + firstString?.slice(1)?.toLowerCase();
              return firstString
              break;
          
            default:
              break;
          }
          break;
        case "includes":
          const secondString = typeof action?.secondString === "object" ? getData(action?.secondString, action?.secondString?.source === "GLOBAL" ? fullGlobalState : storeState, globalState, fullGlobalState, reduxState, collectionStateOrPayload) : action?.secondString;
          const flag = firstString?.includes(secondString ?? "",action?.position);
          return flag ?? false;
          break;
        case "notIncludes":
          const searchString = typeof action?.secondString === "object" ? getData(action.secondString, action.secondString.source === "GLOBAL" ? fullGlobalState : storeState, globalState, fullGlobalState, reduxState, collectionStateOrPayload) : action?.secondString;
          const answer = firstString?.includes(searchString ?? "",action?.position);
          return !answer;
          break;
        case "isNumber":
          return !isNaN(Number(firstString));
          break;
        case "toString":
          return firstString?.toString();
          break;
        //@ts-ignore
        case "decodeURIComponent":
          return decodeURIComponent(firstString);
          break;
          case "length":
            return firstString.length;
            break;
        //@ts-ignore
        case "convertToLabel":
          return convertToLabel(firstString);
          break;
        default:
          break;
      }

    }
  }

  const getFilteredData = (data1: any, data2: any, filter: getFilterState) => {

    switch (filter?.filterType) {
      case "include":
        const baseString = new String(data2);
        return baseString?.toLowerCase()?.includes(data1?.toLowerCase());
        break;
      //@ts-ignore
      case "inArray":
        return data1.includes(data2);
        break;
      // @ts-ignore
      case "notEqual":
        return (data2 !== filter?.value && data2?.toString() !== data1?.toString());
        break;
      //@ts-ignore
      case "equalsIfNotNull":
        if(data1 && data1 !== ""){
          return (data2 === filter?.value || data2?.toString() === data1?.toString());
        }
        return true;
        break;
      default:
        return (data2 === filter?.value || data2?.toString() === data1?.toString());
        break;
    }
  }

  const getDataFromCoockie = ()=>{
    const coockieStore = getAllCookies();
    const data = coockieStore?.[hierarchy.key] ?? "";
    if(hierarchy?.stringActions && hierarchy?.stringActions?.length > 0){
      return resolvedStringOperations(data?.toString() ?? "",hierarchy?.stringActions);
    }
    return data;
  }

  const getDataFromHierarchy: any = (state: any, hierarchy: updateState) => {
    const extractedKey = hierarchy?.dynamicKey ? getData(
      hierarchy?.dynamicKey ?? { key: "" },
      hierarchy?.dynamicKey?.source === "DEFAULT" ? collectionStateOrPayload : hierarchy?.dynamicKey?.source === "GLOBAL"? fullGlobalState : hierarchy?.dynamicKey?.source === "REDUX" ? reduxState : storeState,
      globalState,
      fullGlobalState,
      reduxState,
      collectionStateOrPayload
    ) : hierarchy?.key;
    
    if (
      Array?.isArray(state?.[extractedKey])
    ) {
      return resolveArrayData(state, hierarchy);
    }
    if (hierarchy?.field) {
      return getDataFromHierarchy(state?.[extractedKey], hierarchy?.field);
    }

    if ( 
      Array?.isArray(state?.[extractedKey]) || hierarchy?.type === 'array'
    ) {
      return resolveArrayData(state, hierarchy)
    }

    if((typeof state?.[extractedKey] === "string"  || typeof state?.[extractedKey] === "number" || typeof state === "string" || typeof state === "number") && hierarchy?.stringActions && hierarchy?.stringActions?.length > 0){
      return resolvedStringOperations(state?.[extractedKey]?.toString() ?? state ?? "",hierarchy?.stringActions);
    }

    if(hierarchy?.operations && hierarchy?.operations?.length > 0){
      return extractedKey ? performOperations(state?.[extractedKey], hierarchy?.operations, globalState,fullGlobalState,reduxState,collectionStateOrPayload) : performOperations(state, hierarchy?.operations, globalState,fullGlobalState,reduxState,collectionStateOrPayload);
    }

    if(hierarchy?.objectOperations && hierarchy?.objectOperations?.length > 0){
      return extractedKey ? performObjectOperations(state?.[extractedKey], hierarchy?.objectOperations, globalState,fullGlobalState,reduxState,collectionStateOrPayload) : performObjectOperations(state, hierarchy?.objectOperations, globalState,fullGlobalState,reduxState,collectionStateOrPayload);
    }

    if(extractedKey === undefined && (hierarchy && JSON.stringify(hierarchy) !== "{}")){
      return state;
    } else {
      return state?.[extractedKey];
    }
  };

  if(hierarchy?.source === "COOKIES"){
    const data = getDataFromCoockie();
    return data;
  }
  return getDataFromHierarchy(state, hierarchy);
};

export default getData;
